export default "__VITE_ASSET__cf5RhhdP__"